// Mayfair Menagerie: "Add" buttons in the cart drawer's "Complete the look" box.
// Adds the item, then reloads the page and reopens the cart so totals stay correct.
(() => {
  if (window.mmCompleteLook) return;
  window.mmCompleteLook = true;

  const KEY = 'mmReopenCart';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mm-add]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.mmAdd), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('add failed');
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (e) {}
      window.location.reload();
    } catch (e) {
      button.disabled = false;
      button.textContent = 'Add';
    }
  });

  let reopen = false;
  try {
    reopen = sessionStorage.getItem(KEY) === '1';
    sessionStorage.removeItem(KEY);
  } catch (e) {}
  if (reopen) {
    customElements.whenDefined('theme-drawer').then(() => {
      setTimeout(() => {
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }, 300);
    });
  }
})();
